import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/seeker/app/global-error.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/seeker/app/globals.css");
;
import(/* webpackMode: "eager" */ "/app/apps/seeker/app/helper/ExecuteScript.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/seeker/components/common/defaultHeader/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/seeker/components/common/Footer/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/seeker/providers/ReactQueryProvider.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Noto_Sans\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"variable\":\"--font-noto-sans\"}],\"variableName\":\"notoSans\"}");
